import { useEffect } from 'react';
import { useLocation } from 'react-router';
import {
	initializeAnalytics,
	registerPageLifecycleTracking,
	trackPageNavigation,
} from '@/utils/analytics';

export const usePageAnalytics = () => {
	const location = useLocation();

	useEffect(() => {
		initializeAnalytics();
		registerPageLifecycleTracking();
	}, []);

	useEffect(() => {
		const currentPath = `${location.pathname}${location.search}`;
		const currentTitle = document.title || 'HealthView 360';

		trackPageNavigation(currentPath, currentTitle);
	}, [location.pathname, location.search]);
};
